/* eslint-disable max-len */
import GEN from '../../../../assets/generalDisclosure.png';
import {API_ENDPOINT_JSON} from '../../../../config';

import {
  energyManagement,
  waterManager,
  managementTenant,
  climateChangeQ
} from './realEstateQuestions';

export const realEstateObj = {
  header: {
    imageUrl: GEN,
    title: 'Real Estate',
    description: `Focuses on governance-related aspects, encompassing corporate structure, ethics, 
      board composition, and policies shaping sustainable practices and accountability.`,
    noOfModules: 0,
    answeredQuestions: 0,
    totalQuestions: 0
  },
  APIRoute: API_ENDPOINT_JSON.ESG.SASB.realEstate,
  tabs: [
    {
      id: 'energyManagement',
      title: 'Energy Management',
      questions: energyManagement,
      accordion: true
    },
    {
      id: 'waterManagement',
      title: 'Water Management',
      questions: waterManager,
      accordion: true
    },
    {
      id: 'managementOfTenantSustainabilityImpacts',
      title: 'Management of Tenant Sustainability Impacts',
      questions: managementTenant,
      accordion: true
    },
    {
      id: 'climateChangeAdaptation',
      title: 'Climate Change Adaptation',
      questions: climateChangeQ,
      accordion: true
    }
  ]
};
